import React, { forwardRef } from 'react';
import { useSelector } from 'react-redux';
import MuiLink from '@mui/material/Link';

// In a read-only tenant, non-internal users may browse list screens and open the
// row drawer, but every record-navigation link is rendered as plain text so they
// cannot click through to a detail record. Internal users (even in a read-only
// tenant) keep working links. Action links (print, download) are triggered by
// buttons/menu items, not this component; a rare action-style link can opt back
// in with the `action` prop.
const Link = forwardRef((props, ref) => {
    const readOnly = useSelector(state => state.auth?.user?.readOnly === true);
    const internal = useSelector(state => state.auth?.user?.internal === true);
    const { action, ...rest } = props;
    const isNavigation = rest.href != null || rest.to != null;

    if (readOnly && !internal && isNavigation && !action) {
        // Strip the navigation affordance and render the label as plain text.
        const STRIP = new Set(['href', 'to', 'onClick', 'component', 'target', 'rel', 'underline', 'sx']);
        const passthrough = Object.fromEntries(Object.entries(rest).filter(([k]) => !STRIP.has(k)));
        return (
            <MuiLink
                ref={ref}
                component="span"
                underline="none"
                {...passthrough}
                sx={{ cursor: 'default', color: 'inherit', ...rest.sx }}
            />
        );
    }

    return (
        <MuiLink
            ref={ref}
            {...rest}
            underline={props.underline != null ? props.underline : 'hover'}
            sx={{ cursor: 'pointer', ...props.sx }}
        />
    );
});

Link.displayName = 'Link';

export default Link;
